/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// IF PRODUCT IS READY TO SHIP OR FOR PREORDER

if (window.theme.templateName == "product") {
  const selector = document.querySelector('.ProductForm__Variants [name="id"]');
  const variantId = selector.value;
  const isPreorder = window.theme.isPreorder;
  
  if (isPreorder) {
    setPreorderMessage(variantId);
    
    document.addEventListener('variant:changed', function(event) {
      const variant = event.detail.variant;
      const template = window.theme.templateName;

      setPreorderMessage(variant.id);
    });
  }
}

function setPreorderMessage(variantId) {
  const productAtc = document.querySelector('.ProductForm__AddToCart');
  const quantity = window.inventories[variantId].quantity;
  let preorder = false;

  if (quantity <= 0) {
    preorder = true;
    productAtc.textContent = 'pre-order';
    productAtc.disabled = false;
  } else {
    productAtc.textContent = 'add to cart';
  }

  setPreorderProperty(preorder);
}

function setPreorderProperty(preorder = false) {
  if (preorder) {
    const productForm = document.querySelector('.ProductForm');
    const ctaGroup = document.querySelector('.ProductForm__AddToCart');
    let preorderField = document.querySelector('input[name="properties[Preorder]"]');
    let shippingMsg = document.querySelector('.shipping-msg');

    if (!preorderField) {
      preorderField = document.createElement('input'); 
      preorderField.type = 'hidden';
      preorderField.name = 'properties[Preorder]';
      
      productForm.appendChild(preorderField);
    }

    if (!shippingMsg) {
      shippingMsg = document.createElement('p');
      shippingMsg.classList.add('shipping-msg');
      ctaGroup.parentNode.insertBefore(shippingMsg, ctaGroup.nextSibling);
    }

    let [minDate, maxDate] = calculateShippingDates();

    minDate = minDate.replace(/\//g, '.');
    maxDate = maxDate.replace(/\//g, '.');

    // const shortMinDate = shortenDate(minDate);
    // const shortMaxDate = shortenDate(maxDate);
    
    preorderField.value = `Estimated ship date between: ${minDate} - ${maxDate}`;
    shippingMsg.textContent = `Est. Ship Date Between: ${minDate} - ${maxDate}`;
  } else {
    const preorderField = document.querySelector('input[name="properties[Preorder]"]');
    const shippingMsg = document.querySelector('.shipping-msg');
    
    if (preorderField !== null)
      preorderField.remove();

    if (shippingMsg !== null)
      shippingMsg.remove();
  }
}

function calculateShippingDates() {
  const currentDate = new Date();
  const weeks = window.theme.preorder_weeks.split("-").map(num => num.trim());
  const minWeeks = weeks[0];
  const maxWeeks = weeks[1];
  
  const minDeliveryDate = new Date(currentDate);
  minDeliveryDate.setDate(currentDate.getDate() + minWeeks * 7);
  
  const maxDeliveryDate = new Date(currentDate);
  maxDeliveryDate.setDate(currentDate.getDate() + maxWeeks * 7);

  const minDate = minDeliveryDate.toLocaleDateString();
  const maxDate = maxDeliveryDate.toLocaleDateString();

  return [minDate, maxDate];
}

function shortenDate(date) {
  const formattedDate = date.replace(/\d{4}/, '');
  const shortenedDate = formattedDate.replace('/', '.');

  return shortenedDate.replace(/\//g, '');
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//RCA_AA CODE ADDED TO FIX PRICE UPDATE ON PDP PAGE
 document.addEventListener('variant:changed', function(event) {
    let productPrice = document.querySelector('#price_tochange');
    let moneyFormat = window.theme.moneyFormat;
     var variant = event.detail.variant; 
      productPrice.textContent = formatMoney(variant.price, moneyFormat);
   });

   $(document).ready(function() {
      // if(window.location.pathname == "/cart"){
    
      // }else{
         $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
            $('.main-loader-wrapper').css('visibility','visible')
            $("input:checkbox[name=rush-fee]:checked").each(function(index, value) { 
               setTimeout(()=>{
                  var vid = $(value).data('id');
                  var qty = 1;
                  $.ajax({
                     type: 'POST',
                     url: '/cart/change.js',
                     data: {
                       quantity: 0,
                       id: vid
                     },
                     dataType: 'json', 
                     success: function (data) {
                       $.ajax({
                         type: 'POST',
                         url: '/cart/add.js',
                         data: {
                          quantity: qty,
                          id: vid
                         },
                         dataType: 'json', 
                         success: function (data) { 
                           // $(this).submit();  
                           // window.location.href = "/checkout";
                         } 
                       });
                     },error: function (data) {
                       $.ajax({
                         type: 'POST',
                         url: '/cart/add.js',
                         data: {
                           quantity: qty,
                           id: vid
                         },
                         dataType: 'json', 
                         success: function (data) { 
                           // $(this).submit();  
                           // window.location.href = "/checkout";
                         } 
                       });  
                     } 
                  });    
               }, index * 1000); 
            })
            setTimeout(()=>{
                window.location.href = "/checkout";
            },6000); 
         });   
         setTimeout(function() {
            if(window.Rebuy){ Rebuy.init();}
         },1000);
   });


   document.addEventListener('product:added', function(event) {
     setTimeout(function() {
      if(window.Rebuy){ Rebuy.init();}
     },1000);
   });


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=untamedpetals.com";
}

function getCookie(cname) { 
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length); 
    }
  }
  return ""; 
}


function geoLocation() {

  var storePreference = localStorage.getItem('storePreferenceValue'),
      stayOnStorePreference = getCookie("stayOnStore"),
      cookieStorePreference = getCookie("cookieStorePreferenceNew"),
      
      storeAddress = $('.store-redirect').attr('data-store-address'),
      redirectPopup = $('.redirect-popup'),
      redirectOverlay = $('.redirect-overlay'),
      redirectTargetCountry = $('.redirect-content .target-country'),
      redirectButtonLink = $('.redirect-content .btn-redirect'),
      
      URLPath = window.location.pathname;

  // If customer has not clicked 'Stay on Store' or changed site in site select.
  if (stayOnStorePreference == "") {
      //If store preference is not set....
      if (cookieStorePreference == "") {
          //console.log('preference not set');

          $.ajax({
              url: '//api.ipstack.com/check?access_key=081c786a005130aeec64e5121e65c449',
              dataType: 'json',
              success: function (json) {

                  //If customer is from US
                   if (json.country_code == "GB") {
                      //If customer is from UK
                      //Check to see if store is also UK
                      if (storeAddress === 'https://untamedpetals.co.uk') {
                          //If customer and store are both UK, do nothing. They are were they are supposed to be.
                          //set user store preference
                          setCookie("cookieStorePreferenceNew", "UK", 365)
                      } else {
                          //show redirect popup - with option to redirect to UK.
                          $(redirectTargetCountry).html('UK');
                          $(redirectButtonLink).attr('href', 'https://untamedpetals.co.uk' + URLPath);
                          $(redirectPopup).addClass('active');
                          $(redirectOverlay).addClass('active');  
                      }
                  
                  } else {
                      // IF Customer is not from any of the above
                      //Check to see if store is INT
                      if (storeAddress === 'https://untamedpetals.com') {
                          //set user store preference
                          setCookie("cookieStorePreferenceNew", "INT", 365)
                        console.log("testing");
                      } else {                      
                          //show redirect popup - with option to redirect to US.
                         console.log("tttttt");
                          $(redirectTargetCountry).html('INT');
                          $(redirectButtonLink).attr('href', 'https://untamedpetals.com' + URLPath);
                          $(redirectPopup).addClass('active');
                          $(redirectOverlay).addClass('active');
                      }
                  }
              }
          });

      //IF store preference is set.   
      
      } else if (cookieStorePreferenceNew == "UK") {
          console.log('preference:' +cookieStorePreference);

          //IF store preference is UK. 
          if (storeAddress === 'untamedpetals.co.uk') {
              // and customer is on UK store. Do nothing. 
            $('.redirect-popup').removeClass('active');
      $('.redirect-overlay').removeClass('active');
          } else {
              window.top.location.href = "https://untamedpetals.co.uk" + URLPath; 
          }
      } 
    
      else if (cookieStorePreferenceNew == "INT") {
          //console.log('preference:' +cookieStorePreference);

          //IF store preference is INT. 
          if (storeAddress === 'untamedpetals.com') {
              // and customer is on INT store. Do nothing. 
            $('.redirect-popup').removeClass('active');
            $('.redirect-overlay').removeClass('active');
          } else {
              window.top.location.href = "https://untamedpetals.com" + URLPath; 
          }
      }
    // If customer has set a preference with 'Stay on Store' or changed site in site select and they land on another store - ask if they want to be redirected to their prefered store.
  } else if (stayOnStorePreference == "INT") {
      //IF store preference is US. 
      if (storeAddress === 'untamedpetals.com') {
          // and customer is on US store. Do nothing. 
        $('.redirect-popup').removeClass('active');
      $('.redirect-overlay').removeClass('active');
      } else {
          window.top.location.href = "https://untamedpetals.com" + URLPath;
      }
  } else if (stayOnStorePreference == "UK") {
      //IF store preference is UK. 
      if (storeAddress === 'untamedpetals.co.uk') {
          // and customer is on UK store. Do nothing. 
        $('.redirect-popup').removeClass('active');
      $('.redirect-overlay').removeClass('active');
      } else {
          window.top.location.href = "https://untamedpetals.co.uk" + URLPath;
      }
  } 
}

function redirectClose() {
  $('.redirect-close').off('click').on('click', function(){

      var storeAddress = $('.store-redirect').attr('data-store-address');

      $('.redirect-popup').removeClass('active');
      $('.redirect-overlay').removeClass('active');

       if (storeAddress === 'untamedpetals.co.uk') {
          setCookie("cookieStorePreferenceNew", "UK", 365)
          setCookie("stayOnStore", "UK", 365)
      } else if  (storeAddress === 'untamedpetals.com') {
          setCookie("cookieStorePreferenceNew", "INT", 365)
          setCookie("stayOnStore", "INT", 365)
      } 

  });
}

function redirectCheck() {
 var storeRedirect = $('.store-redirect'); 

 if (storeRedirect.length) {
     geoLocation();
     redirectClose();
 }
}

redirectCheck();
